import React, { useState, useEffect } from 'react';
import { Card, Form, Row, Col, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { handleError } from '../../store/features/alertSlice';
import businessUnitsService from '../../services/business_unit.service';
const BusinessUnitForm = _ref => {
  let {
    company,
    setCompany,
    loading,
    setLoading
  } = _ref;
  const {
    t
  } = useTranslation();
  const [newBusinessUnit, setNewBusinessUnit] = useState({
    name: ''
  });
  const dispatch = useDispatch();
  const handleChange = e => {
    const value = e.target.value;
    setNewBusinessUnit({
      ...newBusinessUnit,
      [e.target.name]: value
    });
  };
  const handleAddBusinessUnit = async () => {
    try {
      const nbu = await businessUnitsService.create(company.id, newBusinessUnit);
      setCompany({
        ...company,
        business_units: [...company.business_units, nbu]
      });
      setNewBusinessUnit({
        name: ''
      });
    } catch (e) {
      dispatch(handleError(e));
    } finally {
      setLoading(false);
    }
  };
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('new_business_unit')), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(Form.Control, {
    name: "name",
    onChange: handleChange,
    value: newBusinessUnit.name,
    size: "md",
    type: "text"
  })), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: newBusinessUnit.name.length < 1,
    onClick: () => handleAddBusinessUnit(),
    icon: "save",
    iconPosition: 'left',
    loading: loading,
    variant: "primary"
  }, t('add_new_business_unit')))))));
};
export default BusinessUnitForm;